// extracted by mini-css-extract-plugin
module.exports = {"text":"MasterItem_text__1fXPT","editText":"MasterItem_editText__3Xjfj"};